module.exports = "/_next/static/images/penfold-banner-sm-e3b2c86365df4ac792d0cc244fd5df4f.png";